module.exports = __webpack_public_path__ + "static/media/charterlogo.bc47c117.png";